import React from 'react'
import {
    Container, Table,
    Row, Col, Label,
    Button, Input,
} from 'reactstrap'
import { getCustomerReport } from '../model/request/customerreport'
import SimpleDropdown from '../view/DropDownView'
import DropDownTextField from '../view/DropDownTextField'
import DateTextField from '../view/DateTextField'
import { formatAsDollarValue, moneyText, dateOffsetText } from '../model/Formatting'
import { Account, Roles } from '../model/Account'
import { getCustomerNames } from '../model/request/quotes'
import { ObjectToParams } from '../model/request/urlparser'
import { addUserTimeZoneJson } from '../model/DateConverter'
import {
    InfoButton,
} from '../view/InfoButton'
import dateFormatTemp from 'dateformat'

function dateFormat(date) {
    if (!date || date.valueOf() <= 0) {
        return ''
    }
    return dateFormatTemp(date.toDateTime(), 'mmmm d, yyyy')
}


class CustomerReportViewController extends React.Component {

    constructor(props) {
        super(props)

        // const lastMonths = new Date()
        // lastMonths.setMonth(lastMonths.getMonth()-6)
        // lastMonths.setDate(1)

        // const tomorrow = new Date()
        // tomorrow.setDate(tomorrow.getDate() + 1)

        // const lastMonth = new Date()
        // lastMonth.setMonth(lastMonth.getMonth()-1)
        // lastMonth.setDate(1)

        // const nextMonth = new Date()
        // nextMonth.setMonth(nextMonth.getMonth()+3)
        // nextMonth.setDate(1)

        const searchTerms = Object.assign({
            'filter': 'All',
            'company': '',
            'from_date': undefined, // lastMonths,
            'to_date': undefined, // tomorrow,
            'from_ship_date': undefined, // lastMonth,
            'to_ship_date': undefined, // nextMonth,
            'no_shipped': false,
            'ready_for_production': false,
        }, props.searchParams)
        searchTerms.only_shipped = searchTerms.only_shipped === 'true'
        searchTerms.no_shipped = searchTerms.no_shipped === 'true'
        searchTerms.ready_for_production = searchTerms.ready_for_production === 'true'

        this.state = {
            'jobs': [],
            'searchTerms': searchTerms,
            'companyNames': [],
        }
    }

    componentDidMount() {
        const account = Account.fromCookieAndLocalStorage()
        if (!account.hasRole(Roles.Asante)) {
            this.search()
        }
    }

    // MARK: Get Data from web server

    search() {
        this.props.searchPage(this.state.searchTerms)
        this.props.turnOnLoader()
        const search = JSON.parse(JSON.stringify(this.state.searchTerms))
        getCustomerReport(search).then(
            (result) => {
                this.setState({
                    'jobs': addUserTimeZoneJson(result.data.jobs),
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    updateCompanyDropDown(customerName) {
        if (customerName.length > 1) {
            getCustomerNames(customerName)
            .then(
                (result) => {
                    this.setState({
                        'companyNames': result.data.customer_names
                    })
                },
                (error) => {
                    this.props.showError(error)
                }
            )
        } else {
            this.setState({
                'companyNames': [],
            })
        }
    }

    // Update states

    updateSearchTerms(varName, value) {
        const searchTerms = this.state.searchTerms
        searchTerms[varName] = value
        this.props.searchPage(searchTerms)
        this.setState({
            'searchTerms': searchTerms,
        })
    }


    // MARK: render

    renderRows() {
        return this.state.jobs.filter((job) =>
            job.lastest_step_label === this.state.searchTerms.filter ||
            this.state.searchTerms.filter === 'All')
            .map((job, index) =>
            <tr>
                <td><Label>{job.given_id}</Label></td>
                <td><Label><a href={'/quote/' + job.id} text={job.job_name}>{job.job_name}</a></Label></td>
                <td><Label><span text={dateOffsetText(job.expected_ship_date)}>{dateFormat(job.expected_ship_date)}</span></Label></td>
                <td><Label><span text={moneyText(job.total_price)}>{formatAsDollarValue(job.total_price)}</span></Label></td>
                <td><Label>{job.lastest_step_label}</Label></td>
                <td><Label><span text={dateOffsetText(job.shipped_date)}>{dateFormat(job.shipped_date)}</span></Label></td>
            </tr>
        )
    }

    renderDropDown(values, value) {
        values = values.filter((x, i) => i === values.indexOf(x) && x !== '')
        values = ['All'].concat(values)
        const index = values.indexOf(value)

        return <SimpleDropdown
            index={index}
            values={values}
            onChange={(i) => {
                this.updateSearchTerms('filter', values[i])
            }} />
    }

    renderHeaderLabelAndView(headerText, view) {
        return <>
            <Row>
                <Col>
                    <Label style={{
                        'fontWeight': '500',
                        'fontSize': '18pt',
                    }} >{headerText}</Label>
                </Col>
            </Row>
            <Row>
                <Col>
                    {view}
                </Col>
            </Row>
        </>
    }

    renderCompanyNameDropDown() {
        return <DropDownTextField value={this.state.searchTerms.company}
            values={this.state.companyNames}
            onChange={(e) => {
                this.updateSearchTerms('company', e.target.value)
                this.updateCompanyDropDown(e.target.value)
            }}
            onClickRow={(value, index) => {
                this.updateSearchTerms('company', value)
                this.updateCompanyDropDown(value)
            }} />
    }

    renderCheckbox(label, varName) {
        return <Row>
            <Col>
            <Label>{label}</Label>
            </Col>
            <Col>
            <Input
            type="checkbox"
            checked={this.state.searchTerms[varName]}
            onChange={(e) => {
                const searchTerms = this.state.searchTerms
                searchTerms[varName] = !searchTerms[varName]
                this.setState({
                    'searchTerms': searchTerms,
                })
            }} />
            </Col>
        </Row>
    }

    renderDateTextField(label, varName) {
        return <Col>
            <Label>{label}</Label>
            <DateTextField
                value={this.state.searchTerms[varName]}
                showModal={this.props.showModal}
                closeModal={this.props.closeModal}
                onChange={(newDate) => {
                    const searchTerms = this.state.searchTerms
                    searchTerms[varName] = newDate
                    this.setState({
                        'searchTerms': searchTerms,
                    })
                }}
            />
        </Col>
    }

    render() {
        const account = Account.fromCookieAndLocalStorage()
        return (
            <Container>
                {
                    this.renderHeaderLabelAndView(
                        'Latest Step',
                        <div style={{
                            'display': 'inline-flex',
                        }}
                        >
                            {
                                this.renderDropDown(this.state.jobs.map(
                                    (job, index) => job.lastest_step_label), this.state.searchTerms.filter)
                            }
                            <InfoButton
                                id={'customerreportviewreport'}
                                message={
                                    'Filter by last step done to a job. ' +
                                    'Only shown steps seen in last search.'
                                }
                                style={{
                                    'margin': '8px',
                                }}
                            />
                        </div>
                    )
                }
                {
                    this.renderHeaderLabelAndView(
                        'Date Quoted',
                        <Container>
                            <Row>
                                {this.renderDateTextField('From', 'from_date')}
                                {this.renderDateTextField('To', 'to_date')}
                            </Row>
                        </Container>
                    )
                }
                {
                    this.renderHeaderLabelAndView(
                        'Date Shipped',
                        <Container>
                            <Row>
                                {this.renderDateTextField('From', 'from_ship_date')}
                                {this.renderDateTextField('To', 'to_ship_date')}
                            </Row>
                        </Container>
                    )
                }
                {
                    this.renderHeaderLabelAndView(
                        'Filters',
                        <Container style={{
                            'float': 'left',
                            'maxWidth': '450px',
                        }}>
                            {this.renderCheckbox('Only Shipped', 'only_shipped')}
                            {this.renderCheckbox('No Shipped', 'no_shipped')}
                            {this.renderCheckbox('Ready For Production', 'ready_for_production')}
                        </Container>
                    )
                }
                {
                    account.hasRole(Roles.Asante) && account.verified ?
                    this.renderHeaderLabelAndView(
                        'Company',
                        this.renderCompanyNameDropDown()
                    )
                    :<></>
                }
                <Row style={{
                    'marginTop': '12px',
                    'marginBottom': '12px',
                }}><Col>
                    <Button
                        color='primary'
                        style={{
                            'float': 'right',
                        }}
                        onClick={(e) => {
                            this.search()
                        }}
                        >Search</Button>

                    <Button
                        style={{
                            'float': 'right',
                             'marginRight': '12px',
                        }}
                        onClick={(e) => {
                            const params = ObjectToParams(this.state.searchTerms)
                            window.location.href = '/api/pdf/customerreport.pdf' + params
                        }}
                        >Download PDF</Button>
                </Col></Row>
                <Row>
                    <Col>
                    <Label style={{
                        'fontSize': '18px',
                        'fontWeight': '450',
                        'marginRight': '8px',
                    }}>Total Price:</Label>
                    <Label style={{
                        'fontSize': '18px',
                        'fontWeight': '400',
                    }}>{(() => {
                        const total = this.state.jobs.length > 0 ?
                            this.state.jobs.map((x) => x.total_price)
                                .reduce((l, r) => l+r) : 0
                        return <span text={moneyText(total)}>{formatAsDollarValue(total)}</span>
                    })()}</Label>
                    </Col>
                </Row>
                <Row style={{
                    'marginBottom': '20px'
                }}><Col><div style={{'overflowX': 'auto'}}><Table>
                    <thead>
                        <tr>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}>Quote ID</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '60px'}}>Job Name</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '100px'}}>Expected Ship Date</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '60px'}}>Total Price</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '60px'}}>Latest Step</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '100px'}}>Date Shipped</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderRows()}
                    </tbody>
                </Table></div></Col></Row>
            </Container>
        )
    }
}

export default CustomerReportViewController

